
































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import { IAction } from "./CommonTypes";

@Component({
  components: {},
})
export default class MoreVertBtn extends Vue {
  @Prop({}) actions: IAction;
  @Prop({}) item: any;

  onSelectedAction(item, action): void {
    this.$emit("onSelectedAction", { item, action });
  }
}
